import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Articles from './Articles';
import TrayModule from '../TrayModule';
import { getSliceColourTheme } from '../../selectors';
import { sliceColourTheme } from '../../styles/theme';
import { colourThemeType } from '../../propTypes';

const EditionTray = ({ className, sliceId, colourTheme }) => (
  <TrayModule className={className} sliceId={sliceId} colourTheme={colourTheme}>
    <Articles sliceId={sliceId} colourTheme={colourTheme} />
  </TrayModule>
);

EditionTray.propTypes = {
  className: PropTypes.string,
  sliceId: PropTypes.number.isRequired,
  colourTheme: colourThemeType,
};

EditionTray.defaultProps = {
  className: undefined,
  colourTheme: sliceColourTheme.white,
};

const mapStateToProps = (state, { sliceId }) => ({
  colourTheme: sliceColourTheme[getSliceColourTheme(state, sliceId)],
});

export default connect(mapStateToProps)(EditionTray);
